module.exports = __webpack_public_path__ + "static/Frogsong4-1914858370eba03cfbea73dbfe25d835.png";